// extracted by mini-css-extract-plugin
export default {"price":"f9-z","priceRow":"g9-z","onSale":"h9-z","msrpLabelPrice":"i9-z","msrpLabel":"j9-z","originalPrice":"k9-z","percentOff":"l9-z"};